import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { Store } from '@ngrx/store';

import { ICart } from '../../../cart/models/cart/i-cart'; // for build, don't remove

import { cartHelper } from '../../../cart/helpers/cart-helper';
import { CartState } from '../../../cart/store/reducers/cart.reducer';
import { CartEventsService } from '../../../cart/services/cart-events.service';
import { getCartLines } from '../../../cart/store/selectors/cart.selectors';

@Component({
  standalone: false,
  selector: 'cart-btn',
  templateUrl: './cart-btn.component.html',
  styleUrls: ['./cart-btn.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CartBtnComponent extends CustomComponent {
  @Input() public isBig: boolean;
  @Input() public isMobile: boolean;
  @Input() public isOverview: boolean;
  @Input() public preventDefaultClick: boolean;
  @Input() public quantityOnly: boolean;

  public quantity: number;

  constructor(private _cartEvents: CartEventsService,
              private _store: Store<CartState>) {
    super();
    this._subscribe();
  }

  public onClick(e) {
    if (this.preventDefaultClick) {
      return;
    }

    e.preventDefault();
    this._cartEvents.toggleCart();
  }

  private _subscribe() {
    this.addSubscriber(this._store.select(getCartLines).subscribe((lines) => {
      this.quantity = cartHelper.getQuantityFromOrderLines(lines);
    }));
  }
}
